module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#E24D42",
      "width": "21px",
      "padding-left": "2px",
      "padding-right": "3px",
      "height": "12px",
      "border-radius": "3px",
      "color": "#2a2a2c",
      "float": "right",
      "margin-top": "10px",
      "margin-left": "4px",
      "line-height": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "21px",
      "text-align": "center",
      "position": "absolute",
      "color": "whitesmoke",
      "font-size": "8px",
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-443b22b8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/icon_text.vue
// module id = /Euc
// module chunks = 81